module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"request_id":"Id запроса","template":"Шаблон","time":"Дата","result":"Результат"},"en":{"request_id":"Request Id","template":"Template","time":"Time","result":"Result"}}')
  delete Component.options._Ctor
}
